module.exports = __webpack_public_path__ + "static/media/rogue4.ca5afed4.jpg";